import React from 'react';
import { Box, Typography } from '@trp-individual-investor-adv-svc/ii-prosp-components';
import { PsBeaconModal, PsBeaconButton } from '../shared/BeaconRegister';
import axiosInstance from '../../actions/AxiosInstance';
import api from '../../actions/EndPoints';
import { log, showModal, closeModal } from '../../Utils';
import { isEmpty } from 'lodash';
import { dispatchOverlayLoad } from '../shared/Analytics';
import ErrorIcon from '../../assets/images/icons/Error_Icon.svg';
import LoadingSpinner from '../../containers/LoadingSpinner';
import { getAppointmentDetails } from '../shared/ApiCalls/ApiCalls';

const ScheduleApptErrorModal = ({ state, dispatch }) => {
    const [isLoading, setLoading] = React.useState(false);

    async function redirectToTimeTrade() {
        try {
            setLoading(true);
            const getTTData = await axiosInstance.get(api.calendarTTAPI, {
                headers: {
                    apikey: `${state.apiKey}`,
                },
            });
            if (getTTData) {
                const { data } = getTTData;
                log(console.log('Appointment Details Call was made on Schedule Appointment Click'));

                if (data !== undefined) {
                    dispatch({
                        type: 'TIME_TRADE_DATA',
                        territoryName: data.territoryName,
                        tType: data.type,
                        parentTerritory: data.parentTerritory,
                        employeeName: data.employeeName,
                        employeeRole: data.employeeRole,
                        invitationId: data.invitationId,
                        employeePhone: data.employeePhone,
                        employeeEmail: data.employeeEmail,
                        schedulingLink: data.schedulingLink,
                        adviceQuestionnaireLink: data.adviceQuestionnaireLink,
                    });
                }
                setLoading(false);
            }
            return getTTData;
        } catch (err) {
            setLoading(false);
            dispatch({
                type: 'TIME_TRADE_FAILURE',
                timeTradeFailure: true,
            });
            throw err;
        }
    }

    const handleOnClick = () => {
        getAppointmentDetails({
            dispatch,
            apiKey: state?.apiKey,
            setLoading,
            externalGroupId: state?.planningGroup?.externalId,
        })
            .then(
                (apptsToDisplay) =>
                    ((apptsToDisplay && isEmpty(apptsToDisplay)) || !apptsToDisplay) &&
                    redirectToTimeTrade()
            )
            .then(() => {
                showModal('banner-schedule-appt-modal');
                closeModal('schedule-appointment-error-modal');
                dispatchOverlayLoad('Schedule Appointment Banner Modal');
            })
            .catch((err) => console.log(err));
    };

    return (
        <PsBeaconModal id="schedule-appointment-error-modal" elevation={3}>
            <Box
                id="schedule-appointment-error-content-container"
                className="beacon-theme-modern-outlook beacon-on-light">
                <Box sx={{ paddingBottom: '12px' }} id="error-img-container">
                    <img src={ErrorIcon} alt="loading-error" id="schedule-appointment-error-icon" />
                </Box>
                <Typography
                    id="schedule-appointment-error-title"
                    type="headline" serif scale={300}
                    sx={{ paddingBottom: '16px' }}>
                    Unable to process your request
                </Typography>
                <Typography
                    id="schedule-appointment-error-content"
                    type="body" loose scale={100}
                    sx={{ paddingBottom: '16px' }}>
                    We are having trouble connecting to our scheduling system at this time. You can
                    retry or close this modal and continue through the questionnaire.
                </Typography>

                <Box
                    id="schedule-appointment-error-button-container"
                    slot="action-zone"
                    sx={{ justifyContent: 'flex-end' }}>
                    <PsBeaconButton
                        id="schedule-appointment-error-button"
                        variant="primary"
                        onClick={handleOnClick}
                        style={{ whiteSpace: 'nowrap' }}>
                        {!isLoading && 'Retry'}
                        {isLoading && <LoadingSpinner scale="mini" text="Loading..." />}
                    </PsBeaconButton>
                </Box>
            </Box>
        </PsBeaconModal>
    );
};

export default ScheduleApptErrorModal;
